import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  max-width: 500px;
  background-color: #fff;
  margin: 0 auto;
  padding: 32px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  border-radius: 4px;
  -webkit-box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
`

export const Title = styled.div`
  ${({ theme }) => css`
    h2 {
      font-size: 24px;
      font-weight: 600;
      line-height: 29.26px;
      text-align: center;
      color: ${theme.colors.primary};
    }
  `}
`

export const Info = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 16px 28px;
    text-align: center;
    font-size: 14px;
    line-height: 20px;

    h3 {
      font-size: 16px;
    }

    .numero-pedido {
      strong {
        font-size: 16px;
        text-decoration: underline;
      }
    }

    .cotacao-st {
      font-size: 14px;
      color: ${theme.colors.primary};
    }

    .boleto-visualizar {
      color: ${theme.colors.primary};

      a {
        font-weight: 600;
        text-decoration: underline;
      }
    }

    .boleto-aviso {
      font-size: 12px;
      font-weight: 300;
      line-height: 15px;
      width: 300px;
    }
  `}
`

export const Button = styled.button`
  ${({ theme }) => css`
    border-radius: 4px;
    border: 2px solid transparent;
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    font-size: 14px;
    padding: 12px;
    margin-bottom: 10px;
    width: 100%;
    text-align: center;
    transition: ${theme.transition.default};
    cursor: pointer;
    background: ${theme.colors.primary};
    color: ${theme.colors.white};

    &:hover {
      background: #a71e26;
    }

    @media (max-width: 1170px) {
      & + .button {
        margin-left: 0;
        margin-top: 8px;
      }
    }
  `}
`
